import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import {
	updateTransportadorasList,
} from "../../redux/slicers/user";
import {
	cnpj_mask,
	createTransportadora,
	getAllData,
	updateTable,
	verificaTipoUsuario,
} from "../../services/Servicos";
import Loading from "../loading/Loading";

import "./Modal.scss";
import ModalError from "./ModalError";
import { getErrorMessage, telefoneMask } from "../../services/helpers";
import ModalErrorPretty from "./ModalErrorPretty";

export default function ModalCriarTransportadora(props) {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.userSlice);
	const filiaisList = user.filiaisList.data;

	const [loading, setLoading] = useState({
		isLoading: false,
		msg: "Salvar",
		style: "primary",
	});

	const [body, setBody] = useState({
		responsavel: user.name,
	});
	
	const [error, setError] = useState({
		show: false,
	});

	const handlerSimpleClose = () =>
		props.setShow((last) => ({ ...last, flag: false }));

	const submitDataEdit = () => {
		if (!body.razao_social) {
			setError({
				show: true,
				message: "Não é possível criar transportadora sem Razão Social.",
			});
			return;
		}
		if (!body.cnpj) {
			setError({
				show: true,
				message: "Não é possível criar transportadora sem CNPJ.",
			});
			return;
		}
		if (!body.nome_fantasia) {
			setError({
				show: true,
				message: "Não é possível criar transportadora sem Nome Fantasia.",
			});
			return;
		}

		setLoading({
			isLoading: true,
			msg: "Salvando",
			style: "warning",
		});

		let fBody = {};
		Object.keys(body).forEach((e) => {
			fBody[e] = body[e];
		});

		createTransportadora(fBody)
			.then((response) => {
				setLoading({
					isLoading: false,
					msg: "Enviado",
					style: "success",
				});
				setTimeout(() => {
					updateTransportadoraListArray();
				}, 700);
			})
			.catch((error) => {
				if (error.response?.data?.errors) {
					setError({
						show: true,
						message: "Transportadora já Cadastrada Anteriormente",
					});
				} else {
					setError({
						show: true,
						message: getErrorMessage(error.response) || error.message,
					});
				}
				setLoading({
					isLoading: false,
					msg: "Error",
					style: "danger",
				});

				setTimeout(() => {
					setLoading({
						isLoading: false,
						msg: "Enviar",
						style: "primary",
					});
				}, 1000);
			});
	};

	const onChangeInput = (e) => {
		if (e.target.name === "cnpj") {
			setBody((last) => ({
				...last,
				[e.target.name]: cnpj_mask(e.target.value),
			}));
			return;
		}
		if (e.target.name === "telefone") {
			setBody((last) => ({
				...last,
				[e.target.name]: telefoneMask(e.target.value),
			}));
			return;
		}
		if (e.target.name === "email") {
			setBody((last) => ({
				...last,
				[e.target.name]: e.target.value,
			}));
			return;
		}
		setBody((last) => ({
			...last,
			[e.target.name]: e.target.value.toUpperCase(),
		}));
	};

	const updateTransportadoraListArray = () => {
		getAllData("transportadoras")
			.then((response) => {
				dispatch(updateTransportadorasList(response.data));
				handlerSimpleClose();
			})
			.catch((err) => {
				setError({
					show: true,
					message: getErrorMessage(err),
				});
			})
			.finally(() => {
				setLoading({
					isLoading: false,
					msg: "Enviar",
					style: "primary",
				});
			});
	};

	return (
		<>
			<Modal
				show={props.show}
				onHide={handlerSimpleClose}
				backdrop="static"
				keyboard={false}
				centered
				size="md"
			>
				<Modal.Header closeButton>
					<Modal.Title>{props.title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form
						onSubmit={(e) => {
							e.preventDefault();
							submitDataEdit();
						}}
					>
						<h4>Dados da Transportadora</h4>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>Razão Social:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="razao_social"
									onChange={onChangeInput}
									value={body.razao_social || ""}
									required
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>Nome Fantasia:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="nome_fantasia"
									onChange={onChangeInput}
									value={body.nome_fantasia || ""}
									required
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>CNPJ:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="cnpj"
									onChange={onChangeInput}
									value={body.cnpj || ""}
									maxLength={18}
									required
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>Inscrição Estadual:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="inscricao_estadual"
									onChange={onChangeInput}
									value={body.inscricao_estadual || ""}
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>Endereço:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="endereco"
									onChange={onChangeInput}
									value={body.endereco || ""}
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>E-mail:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="email"
									name="email"
									onChange={onChangeInput}
									value={body.email || ""}
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>Telefone:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="telefone"
									onChange={onChangeInput}
									value={body.telefone || ""}
									maxLength={15}
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>RNTRC:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="rntrc"
									onChange={onChangeInput}
									value={body.rntrc || ""}
								/>
							</Col>
						</Row>
						
						<button type="submit" hidden></button>
					</Form>
				</Modal.Body>
				<Modal.Footer>
					<Row style={{ width: "100%" }}>
						<Col>
							<Button
								type="submit"
								variant={loading.style}
								onClick={submitDataEdit}
								disabled={loading.style == "primary" ? false : true}
							>
								{loading.isLoading ? (
									<Loading msg={loading.msg} />
								) : (
									loading.msg
								)}
								{loading.style == "success" ? (
									<i className="bi bi-check"></i>
								) : (
									""
								)}
							</Button>
						</Col>
						<Col>
							<Button variant="secondary" onClick={handlerSimpleClose}>
								Cancelar
							</Button>
						</Col>
					</Row>
				</Modal.Footer>
				{error.show ? (
					<ModalErrorPretty
						setShow={setError}
						{...error}
					/>
				) : (
					""
				)}
			</Modal>
		</>
	);
}
